import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { trackAppEvent } from 'app/AppTracker';
import { ClientView, GarageView, getSparePartsView, setSparePartsView, SPARE_PARTS_VIEW_STORE_KEY } from 'domains/user';
import { TRACKING_EVENT_CLIENT_VIEW, TRACKING_EVENT_GARAGE_VIEW } from 'utils/eventTracker/EventTracker.types';
import { storeSave } from 'utils/storage';
import { Tab, TabsTitle } from './Tabs';
import { SViewTabs } from './Tabs.styled';

interface ViewTabsProps {
  margin?: string;
}

const ViewTabs = ({ margin }: ViewTabsProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const sparePartsView = useSelector(getSparePartsView);

  const handleOnChange = (value: string) => {
    if (value === GarageView && sparePartsView !== GarageView) {
      trackAppEvent(TRACKING_EVENT_GARAGE_VIEW);
    }
    if (value === ClientView && sparePartsView !== ClientView) {
      trackAppEvent(TRACKING_EVENT_CLIENT_VIEW);
    }
    dispatch(setSparePartsView(value));
    storeSave(SPARE_PARTS_VIEW_STORE_KEY, value);
  };

  return (
    <SViewTabs type={'card'} activeKey={sparePartsView} onChange={handleOnChange} $margin={margin}>
      <Tab
        tab={<TabsTitle data-cy={'garage-view-button'}>{t('common.view.garage_view', 'Garage View')}</TabsTitle>}
        key={GarageView}
      />
      <Tab
        tab={<TabsTitle data-cy={'client-view-button'}>{t('common.view.client_view', 'Client View')}</TabsTitle>}
        key={ClientView}
      />
    </SViewTabs>
  );
};

export default ViewTabs;
